export enum Skill {
  General = 'general',
  Swimming = 'swimming',
  Cycling = 'cycling',
  Running = 'running',
  Multisport = 'multisport',
  Involvement = 'involvement',
}
